import { createSlice } from "@reduxjs/toolkit";
import axiosGeneral from "helpers/axios/axiosGeneral";
import { getCurrentToken, selectMyGuid } from "./authSlice";
import { ADMIN_CODE, MEMBER_CODE } from "constants/constants";
import { MAX_MEMBER_BATCH_SIZE } from "constants/constants";
import { setGeneralModal } from "./generalSlice";
import { setRoleId } from "./efficeCacheSlice";
let dispatch = null;
let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  getState = module.store.getState;
});

export const ONLY_ADMIN_TEXT_TYPE = 1;
export const ALL_MEMBERS_TEXT_TYPE = 0;
export const ANCESTOR = "ANCESTOR";
export const PERMISSIONS = "PERMISSIONS";

let INITIAL_STATE = {
  spacePeople: null,
  permissionsMembers: null,
  permissionsMembersAvailable: null,
  permissionsMembersLast: null,
  ancestorMembers: null,
  ancestorMembersAvailable: null,
  ancestorMembersLast: null,
};
// anything starting with PP is related to the PEOPLE PAGE of the HEADER

export const slice = createSlice({
  name: "people",
  initialState: INITIAL_STATE,
  reducers: {
    addPermissionsMembers: (state, action) => {
      let newPeeps = action.payload;
      if (state.permissionsMembers === null) {
        state.permissionsMembers = [];
      }
      state.permissionsMembers = state.permissionsMembers.concat(newPeeps);
      state.permissionsMembersAvailable =
        newPeeps.length === MAX_MEMBER_BATCH_SIZE;
      state.permissionsMembersLast =
        newPeeps.length > 0 ? newPeeps[newPeeps.length - 1].member_id : null;
    },
    addAncestorMembers: (state, action) => {
      let newPeeps = action.payload;
      if (state.ancestorMembers === null) {
        state.ancestorMembers = [];
      }
      state.ancestorMembers = state.ancestorMembers.concat(newPeeps);
      state.ancestorMembersAvailable =
        newPeeps.length === MAX_MEMBER_BATCH_SIZE;
      state.ancestorMembersLast =
        newPeeps.length > 0 ? newPeeps[newPeeps.length - 1].member_id : null;
    },
    addMember: (state, action) => {
      let newUserId = action.payload;
      state.ancestorMembers.forEach((elem) => {
        if (elem.id === newUserId && state.permissionsMembers !== null)
          state.permissionsMembers.unshift({ ...elem, role_id: MEMBER_CODE });
      });
    },
    removeMember: (state, action) => {
      let removedUserId = action.payload;
      if (state.permissionsMembers) {
        state.permissionsMembers = state.permissionsMembers.filter((elem) => {
          if (elem.id === removedUserId) {
            if (state.ancestorMembers !== null) {
              state.ancestorMembers.unshift({ ...elem, role_id: MEMBER_CODE });
            }
            return false;
          }
          return true;
        });
      }
    },
    setMemberRoleId: (state, action) => {
      state.permissionsMembers.forEach((user) => {
        if (user.id === action.payload.user_id) {
          user.role_id = action.payload.role_id;
        }
      });
    },
    setSpaceRoleId: (state, action) => {
      let { uuid, value } = action.payload;
      state.spacePeople.forEach((person) => {
        if (person.id === uuid) {
          person.role_id = value;
        }
      });
    },
    resetAncestorMembers: (state) => {
      state.ancestorMembers = null;
      state.ancestorMembersAvailable = null;
      state.ancestorMembersLast = null;
    },
    resetPermissionsMembers: (state) => {
      state.permissionsMembers = null;
      state.permissionsMembersAvailable = null;
      state.permissionsMembersLast = null;
    },
  },
});

export const {
  addPermissionsMembers,
  addAncestorMembers,
  addMember,
  removeMember,
  setMemberRoleId,
  setSpaceRoleId,
  resetAncestorMembers,
  resetPermissionsMembers,
} = slice.actions;

//#region  FETCHING MEMBER DATA

export const getPermissionsMembers =
  (effId, more = false) =>
  async (dispatch, getState) => {
    return new Promise(async (res, rej) => {
      let route = `/effice/${effId}/members/permissions?n=${MAX_MEMBER_BATCH_SIZE}`;
      if (more) {
        route = route + `&afta=${getState().people.permissionsMembersLast}`;
      }

      await getCurrentToken()
        .then((idToken) => {
          axiosGeneral
            .get(route, {
              headers: {
                Authorization: "Bearer " + idToken,
              },
            })
            .then((response) => {
              window.efs_debug &&
                window.log("Get Permissions Members Response: ");
              window.efs_debug && window.log(response);
              dispatch(addPermissionsMembers(response.data));
              res(response.data);
            })
            .catch((error) => {
              window.efs_debug &&
                window.log("Failed to Get Permissions Members from Server");
              window.efs_debug && window.log(error);
              rej(error);
            });
        })
        .catch(() => {
          rej();
        });
    });
  };

export const getAncestorMembers = (effId, more = false) => {
  return new Promise(async (res, rej) => {
    let route = `/effice/${effId}/members/ancestor?n=${MAX_MEMBER_BATCH_SIZE}`;
    if (more) {
      route = route + `&afta=${getState().people.ancestorMembersLast}`;
    }

    getCurrentToken()
      .then((idToken) => {
        axiosGeneral
          .get(route, {
            headers: {
              Authorization: "Bearer " + idToken,
            },
          })
          .then((response) => {
            window.efs_debug && window.log("Get Ancestor Members Response: ");
            window.efs_debug && window.log(response);
            dispatch(addAncestorMembers(response.data));
            res(response.data);
          })
          .catch((error) => {
            window.efs_debug &&
              window.log("Failed to Get Ancestor Members from Server");
            window.efs_debug && window.log(error);
            rej(error);
          });
      })
      .catch(() => {
        rej();
      });
  });
};
//#endregion

//#region  ADDING AND REMOVING FROM EFFICE
export const addToEffice = (effice_id, user_id) => {
  return new Promise((res, rej) => {
    getCurrentToken()
      .then((idToken) => {
        axiosGeneral
          .post(`/effice/${effice_id}/member?user_id=${user_id}`, null, {
            headers: {
              Authorization: "Bearer " + idToken,
            },
          })
          .then((response) => {
            window.efs_debug && window.log("Success Add Member Response: ");
            window.efs_debug && window.log(response);
            res(response.data);
            dispatch(addMember(response.data.user));
          })
          .catch((error) => {
            if (error.response) {
              switch (error.response.status) {
                case 403:
                  dispatch(
                    setGeneralModal({
                      title: "Cannot Add",
                      content: error.response.data.errors.detail,
                    })
                  );
                  break;
                default:
                  break;
              }
            }
            window.efs_debug && window.log("Failed to Add Member from Server");
            window.efs_debug && window.log(error);
            rej(error);
          });
      })
      .catch(() => {
        rej();
      });
  });
};
export const removeFromEffice =
  (effice_id, user_id) => async (dispatch, getState) => {
    return new Promise((res, rej) => {
      getCurrentToken()
        .then((idToken) => {
          axiosGeneral
            .delete(`/effice/${effice_id}/member?user_id=${user_id}`, {
              headers: {
                Authorization: "Bearer " + idToken,
              },
            })
            .then((response) => {
              window.efs_debug && window.log("Successfully deleted member: ");
              window.efs_debug && window.log(response);
              let userId = response.data.user;
              res(response.data);
              let elemToRemove = document.getElementById(
                `PeopleItem-${userId}`
              );
              elemToRemove.classList.add("removing");
              setTimeout(() => {
                dispatch(removeMember(userId));
              }, 250);
            })
            .catch((error) => {
              window.efs_debug && window.log("Failed to delete member");
              window.efs_debug && window.log(error);
              if (error.response) {
                switch (error.response.status) {
                  case 403:
                    dispatch(
                      setGeneralModal({
                        title: "Could Not Remove Member",
                        content: error.response.data.errors.detail,
                      })
                    );
                    break;
                  default:
                    break;
                }
              }

              rej(error);
            });
        })
        .catch(() => {
          rej();
        });
    });
  };

export const leaveEffice = (effice_id) => async (dispatch, getState) => {
  return new Promise((res, rej) => {
    getCurrentToken()
      .then((idToken) => {
        axiosGeneral
          .delete(`/effice/${effice_id}/leave`, {
            headers: {
              Authorization: "Bearer " + idToken,
            },
          })
          .then((response) => {
            window.efs_debug && window.log("Successfully left effice: ");
            window.efs_debug && window.log(response);
            res(response.data);
          })
          .catch((error) => {
            window.efs_debug && window.log("Failed to leave effice");
            window.efs_debug && window.log(error);
            if (error.response) {
              switch (error.response.status) {
                case 403:
                  dispatch(
                    setGeneralModal({
                      title: "Could Not Leave This Effice",
                      content: error.response.data.errors.detail,
                    })
                  );
                  break;
                default:
                  break;
              }
            }

            rej(error);
          });
      })
      .catch(() => {
        rej();
      });
  });
};

//#endregion

//#region  CHANGING MEMBER ROLES AND PERMISSIONS

export const changeEfficePermissions =
  (effice_id, num_type) => async (dispatch, getState) => {
    return new Promise((res, rej) => {
      let only_admins = null;
      if (num_type === ONLY_ADMIN_TEXT_TYPE) {
        only_admins = true;
      } else if (num_type === ALL_MEMBERS_TEXT_TYPE) {
        only_admins = false;
      } else {
        rej();
        return;
      }
      getCurrentToken()
        .then((idToken) => {
          axiosGeneral
            .patch(`/effice/${effice_id}/only_admins/${only_admins}`, null, {
              headers: {
                Authorization: "Bearer " + idToken,
              },
            })
            .then((response) => {
              window.efs_debug &&
                window.log("Successfully set permissions type: ");
              window.efs_debug && window.log(response);
              res(response.data);
            })
            .catch((error) => {
              dispatch(
                setGeneralModal({
                  title: "Could Not Change Effice Typing Permissions",
                  content: error?.response?.data?.errors?.detail
                    ? error.response.data.errors.detail
                    : "",
                })
              );
              window.efs_debug && window.log("Failed to set permissions type");
              window.efs_debug && window.log(error);
              rej(error);
            });
        })
        .catch(() => {
          rej();
        });
    });
  };

export const setMemberRole =
  (effice_id, user_id, role_id) => async (dispatch, getState) => {
    return new Promise((res, rej) => {
      getCurrentToken()
        .then((idToken) => {
          axiosGeneral
            .patch(
              `/effice/${effice_id}/member?user_id=${user_id}&role_id=${role_id}`,
              null,
              {
                headers: {
                  Authorization: "Bearer " + idToken,
                },
              }
            )
            .then((response) => {
              window.efs_debug && window.log("Successfully set role id: ");
              window.efs_debug && window.log(response);

              dispatch(
                setMemberRoleId({
                  user_id: response.data.user.user_id,
                  role_id: response.data.user.role_id,
                })
              );
              if (response.data.user.user_id === selectMyGuid(getState())) {
                dispatch(
                  setRoleId({
                    effId: effice_id,
                    role_id: response.data.user.role_id,
                  })
                );
              }
              res(response.data);
            })
            .catch((error) => {
              window.efs_debug && window.log("Failed to set role id");
              window.efs_debug && window.log(error);
              if (error.response) {
                switch (error.response.status) {
                  case 403:
                    dispatch(
                      setGeneralModal({
                        title: "Could Not Change Member Role",
                        content: error.response.data.errors.detail,
                      })
                    );
                    break;
                  default:
                    break;
                }
              }
              rej(error);
            });
        })
        .catch(() => {
          rej();
        });
    });
  };

export const makeAdmin = (effice_id, user_id) => async (dispatch) =>
  dispatch(setMemberRole(effice_id, user_id, ADMIN_CODE));

export const removeAsAdmin = (effice_id, user_id) => async (dispatch) =>
  dispatch(setMemberRole(effice_id, user_id, MEMBER_CODE));

//#endregion

//#region  INVITE CODE HANDLING

// Promise succeeds if no code is available, fails if unauthorised or server error
export const getInviteCode = (effId) => {
  return new Promise((res, rej) => {
    getCurrentToken()
      .then((idToken) => {
        axiosGeneral
          .get(`/effice/${effId}/invite_code`, {
            headers: {
              Authorization: "Bearer " + idToken,
            },
          })
          .then((response) => {
            window.efs_debug &&
              window.log("Successfully retrieved invite_code");
            window.efs_debug && window.log(response);
            res(response.data.invite_code.code);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              res(null);
            } else {
              window.efs_debug && window.log("Failed to retrieve invite_code");
              window.efs_debug && window.log(error);
              dispatch(
                setGeneralModal({
                  title: "Error",
                  content: "Could not get the invite link, try again later",
                })
              );
              rej(error);
            }
          });
      })
      .catch(() => {
        rej();
      });
  });
};

export const createInviteCode = (effId, hours = 24 * 7) => {
  return new Promise((res, rej) => {
    getCurrentToken()
      .then((idToken) => {
        axiosGeneral
          .post(`/effice/${effId}/invite_code?hours=${hours}`, null, {
            headers: {
              Authorization: "Bearer " + idToken,
            },
          })
          .then((response) => {
            window.efs_debug && window.log("Successfully created invite_code");
            window.efs_debug && window.log(response);
            res(response.data.invite_code.code);
          })
          .catch((error) => {
            window.efs_debug && window.log("Failed to create invite_code");
            window.efs_debug && window.log(error);
            dispatch(
              setGeneralModal({
                title: "Error",
                content: "Could not create the invite link, try again later",
              })
            );
            rej(error);
          });
      })
      .catch(() => {
        rej();
      });
  });
};

export const deleteInviteCode = (effId) => {
  return new Promise((res, rej) => {
    getCurrentToken()
      .then((idToken) => {
        axiosGeneral
          .delete(`/effice/${effId}/invite_code`, {
            headers: {
              Authorization: "Bearer " + idToken,
            },
          })
          .then((response) => {
            window.efs_debug && window.log("Successfully deleted invite_code");
            window.efs_debug && window.log(response);
            res(response.data);
          })
          .catch((error) => {
            window.efs_debug && window.log("Failed to delete invite_code");
            window.efs_debug && window.log(error);
            dispatch(
              setGeneralModal({
                title: "Error",
                content: "Could not disable the invite link, try again later",
              })
            );
            rej(error);
          });
      })
      .catch(() => {
        rej();
      });
  });
};

//#endregion

export const selectMemberSideAcc = (state) => state.people.memberSideAcc;
export const selectPeopleModal = (state) => state.people.peopleModal;
export const selectInviteCode = (state) => state.people.inviteCode;
export const selectSpacePeople = (state) => state.people.spacePeople;
export const selectPermissionsMembers = (state) =>
  state.people.permissionsMembers;
export const selectPermissionsMembersAvailable = (state) =>
  state.people.permissionsMembersAvailable;
export const selectAncestorMembers = (state) => state.people.ancestorMembers;
export const selectAncestorMembersAvailable = (state) =>
  state.people.ancestorMembersAvailable;

export default slice.reducer;
